
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import simplify from "@turf/simplify";
import LayerPowerline		from "../classes/LayerPowerline";

const DrawLineString = MapboxDraw.modes.draw_line_string;
const geojsonTypes = MapboxDraw.constants.geojsonTypes;
const cursors = MapboxDraw.constants.cursors;
const types = MapboxDraw.constants.types;
const updateActions = MapboxDraw.constants.updateActions;
const modes = MapboxDraw.constants.modes;
const events = MapboxDraw.constants.events;

let tempState;

const powerlineMode = Object.assign({}, DrawLineString)

powerlineMode.user_color = "#5078FF";

powerlineMode.onSetup = function(opts) {
	opts = opts || {};
	
	let line, currentVertexPosition = (opts.startCoordinate ? 1 : 0);
	this.onFinish = opts.onFinish;
	if(opts.powerlines)
		this.powerlines = opts.powerlines;
	if(opts.toolPowerline)
		this.toolPowerline = opts.toolPowerline;
	
	
	let direction = 'forward';
	
	line = this.newFeature({
		type: geojsonTypes.FEATURE,
		properties: {
			color:powerlineMode.user_color,
			width:powerlineMode.user_width
		},
		geometry: {
			type: geojsonTypes.LINE_STRING,
			coordinates: opts.startCoordinate ? [opts.startCoordinate] : []
		},
		id:'added_powerline'
	});


	this.addFeature(line);
	
	this.clearSelectedFeatures();
		
	this.updateUIClasses({ mouse: cursors.ADD });
	this.setActionableState({
		trash: true
	});

	var state = {
		line,
		currentVertexPosition: currentVertexPosition,
		dragMoving: false,
		direction
	}
	if(opts.handles && opts.handles.length)
		this.onHandleClick(opts.handles, state);
	
	return state;
};

powerlineMode.onRightDrag =  function (e){
	tempState.dragMoving = true;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	tempState.currentVertexPosition++;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
}

powerlineMode.onMouseDown = function(state, e) {
  console.log(state);
};

powerlineMode.onRightDrag =  function (e){
	tempState.dragMoving = true;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	tempState.currentVertexPosition++;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
}



powerlineMode.onMouseDown = function(state, e) {
	
	tempState = state;
	
	if(e.originalEvent.which == 3){
		
		this.map.on("mousemove", powerlineMode.onRightDrag);
		
		
	}
  
};

powerlineMode.onMouseUp = function (state, e){
	if (e.originalEvent.which == 3 && state.dragMoving) {
		tempState.dragMoving = false;
		this.map.off("mousemove", powerlineMode.onRightDrag);
		//this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
	}
}
powerlineMode.onHandleClick = function(handles, state) {
	
	if(handles.length){
		const powerlineId = handles[0].properties.powerlineid;
		const direction = handles[0].properties.position;
		
		var idx = this.powerlines.findIndex((p)=>{
			return p.powerlineid == powerlineId || (p.properties && p.properties.tempid == powerlineId);
		});

		if(idx>-1){
			const geo = structuredClone(this.powerlines[idx].geometry);
			
			geo.coordinates = geo.type == "MultiLineString" ? geo.coordinates[0] : geo.coordinates;
			
			if(direction == 1){
				
				if(state.line.coordinates.length<2){
					geo.coordinates.reverse();
					state.line.setCoordinates([...geo.coordinates, ...state.line.coordinates]);
				}
				else{
					state.line.coordinates.pop();
					state.line.setCoordinates([...state.line.coordinates, ...geo.coordinates]);
				}
			}
			else {
				if(state.line.coordinates.length<2){
					state.line.setCoordinates([...geo.coordinates]);
				}
				else{
					geo.coordinates.reverse();
					state.line.coordinates.pop();
					state.line.setCoordinates([...state.line.coordinates, ...geo.coordinates]);
				}
			}
			
			delete this.powerlines[idx].geometry;
			
			state.currentVertexPosition = state.line.coordinates.length;
			
			return; 	
		}
		
	}
}
powerlineMode.onIntersect = function(intersects, state, e){
	
	if(intersects.length){
		const coords = [e.lngLat.lng, e.lngLat.lat];
		
		const powerlineId = intersects[0].properties.powerlineid;
		var idx = this.powerlines.findIndex((p)=>{
			return p.powerlineid == powerlineId || (p.properties && p.properties.tempid == powerlineId);
		});

		if(idx>-1){
			const points = this.powerlines[idx].geometry.type == "MultiLineString" ? this.powerlines[idx].geometry.coordinates[0] : this.powerlines[idx].geometry.coordinates;
			
			const i = this.findIntersect(points, coords);
			
			if(i !== false){
				points.splice(i, 0, coords);
			}
			
			state.line.addCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
			this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
		}
	}	
}

powerlineMode.findIntersect = function(line, coords){
	

	var i = line.findIndex((c, idx)=>{
		
		if(line[idx+1]){
			return 	(
					(coords[0] >= c[0]  && coords[0] <= line[idx+1][0]) 
					|| 
					(coords[0] <= c[0]  && coords[0] >= line[idx+1][0])
				) && (
					(coords[1] >= c[1]  && coords[1] <= line[idx+1][1]) 
					|| 
					( coords[1] <= c[1]  && coords[1] >= line[idx+1][1])
				);
		
		}
		return false;
	});
	
	if(i > -1)
		return i+1;
	
	return false;
	
}
powerlineMode.clickOnVertex = function(state) {
  return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
};
powerlineMode.clickAnywhere = function(state, e) {
	/*
	var handles = this.map.queryRenderedFeatures(e.point, {layers:[LayerPowerline.handlesId]});
	
	var intersects = this.map.queryRenderedFeatures(e.point, {layers:[LayerPowerline.bufferId]});
	
	
	if(handles && handles.length){
		this.onHandleClick(handles, state);
		return;
	}
	if(intersects && intersects.length){
		this.onIntersect(intersects, state, e);
		return;
	}
	*/
	
	if (state.currentVertexPosition > 0 && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition - 1]) ||
		state.direction === 'backwards' && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition + 1])) {
		return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
	}
	this.updateUIClasses({ mouse: cursors.ADD });
	state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	if (state.direction === 'forward') {
		state.currentVertexPosition++;
		state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	}
	else {
		state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
	}
};
powerlineMode.onTouchEnd = function(state, e) {
	this.onMouseUp(state, e)
}

powerlineMode.fireUpdate = function() {
	this.map.fire(events.UPDATE, {
		action: updateActions.MOVE,
		features: this.getSelected().map(f => f.toGeoJSON())
	});
};

powerlineMode.simplify = function(polygon) {
	const tolerance = 1 / Math.pow(1.05, 100 * this.map.getZoom()); // https://www.desmos.com/calculator/nolp0g6pwr
	simplify(polygon, {
		mutate: true,
		tolerance: tolerance,
		highQuality: true
	});
};

powerlineMode.toDisplayFeatures = function(state, geojson, display) {
	const isActiveLine = geojson.properties.id === state.line.id;
	geojson.properties.active = (isActiveLine) ? MapboxDraw.constants.activeStates.ACTIVE : MapboxDraw.constants.activeStates.INACTIVE;
	if (!isActiveLine) return display(geojson);
	// Only render the line if it has at least one real coordinate
	if (geojson.geometry.coordinates.length < 2) return;
	geojson.properties.meta = MapboxDraw.constants.meta.FEATURE;
	
	var vertex = MapboxDraw.lib.createVertex(
		state.line.id,
		geojson.geometry.coordinates[state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1],
		`${state.direction === 'forward' ? geojson.geometry.coordinates.length - 2 : 1}`,
		false
	);
	
	vertex.properties.user_color = powerlineMode.user_color;
	
	display(vertex);

	display(geojson);
};
	
export default powerlineMode